import ConsultationService from '@/services/consultation.service';
import axios from "axios";

export const consultationModule = {
    namespaced: true,
    state: {
        requests: [],
        consultations: new Map(),
        consultationSchedules: new Map(),
        consultationSessions: new Map(),
        consultationExams: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async listConsultations({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listConsultations");
            return ConsultationService.listConsultations(axiosSource).then(
                async data => {
                    commit('updateConsultationsList', data);
                    await dispatch('clearRequest', "listConsultations");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createConsultation({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConsultation");
            return ConsultationService.createConsultation(axiosSource, data).then(
                async data => {
                    commit('insertConsultation', data)
                    await dispatch('clearRequest', "createConsultation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateConsultation({commit, dispatch}, {consultationId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateConsultation");
            return ConsultationService.updateConsultation(axiosSource, consultationId, data).then(
                async data => {
                    commit('updateConsultationData', data)
                    await dispatch('clearRequest', "updateConsultation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteConsultation({commit, dispatch}, consultationId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteConsultation");
            return ConsultationService.deleteConsultation(axiosSource, consultationId).then(
                async data => {
                    commit('removeConsultationFromList', consultationId)
                    await dispatch('clearRequest', "deleteConsultation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listConsultationSchedules({commit, dispatch}, consultationId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listConsultationSchedules");
            return ConsultationService.listConsultationSchedules(axiosSource, consultationId).then(
                async data => {
                    commit('updateConsultationSchedulesList', data);
                    await dispatch('clearRequest', "listConsultationSchedules");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createConsultationSchedule({commit, dispatch}, {consultationId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConsultationSchedule");
            return ConsultationService.createConsultationSchedule(axiosSource, consultationId, data).then(
                async data => {
                    commit('insertConsultationSchedule', data)
                    await dispatch('clearRequest', "createConsultationSchedule");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateConsultationSchedule({commit, dispatch}, {consultationId, consultationScheduleId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateConsultationSchedule");
            return ConsultationService.updateConsultationSchedule(axiosSource, consultationId, consultationScheduleId, data).then(
                async data => {
                    commit('updateConsultationScheduleData', data)
                    await dispatch('clearRequest', "updateConsultationSchedule");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteConsultationSchedule({commit, dispatch}, {consultationId, consultationScheduleId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteConsultationSchedule");
            return ConsultationService.deleteConsultationSchedule(axiosSource, consultationId, consultationScheduleId).then(
                async data => {
                    commit('removeConsultationScheduleFromList', consultationScheduleId)
                    await dispatch('clearRequest', "deleteConsultationSchedule");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async addUserToConsultationSchedule({dispatch}, {consultationId, consultationScheduleId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "addUserToConsultationSchedule");
            return ConsultationService.addUserToConsultationSchedule(axiosSource, consultationId, consultationScheduleId).then(
                async data => {
                    await dispatch('clearRequest', "addUserToConsultationSchedule");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listConsultationSessions({commit, dispatch}, userId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listConsultationSessions");
            return ConsultationService.listConsultationSessions(axiosSource, userId).then(
                async data => {
                    commit('updateConsultationSessionsList', data);
                    await dispatch('clearRequest', "listConsultationSessions");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createConsultationSession({commit, dispatch}, {userId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConsultationSession");
            return ConsultationService.createConsultationSession(axiosSource, userId, data).then(
                async data => {
                    commit('insertConsultationSession', data)
                    await dispatch('clearRequest', "createConsultationSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateConsultationSession({commit, dispatch}, {userId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateConsultationSession");
            return ConsultationService.updateConsultationSession(axiosSource, userId, data).then(
                async data => {
                    commit('updateConsultationSessionData', data)
                    await dispatch('clearRequest', "updateConsultationSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteConsultationSession({commit, dispatch}, {userId, consultationSessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteConsultationSession");
            return ConsultationService.deleteConsultationSession(axiosSource, userId, consultationSessionId).then(
                async data => {
                    commit('removeConsultationSessionFromList', consultationSessionId)
                    await dispatch('clearRequest', "deleteConsultationSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listConsultationExams({commit, dispatch}, userId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listConsultationExams");
            return ConsultationService.listConsultationExams(axiosSource, userId).then(
                async data => {
                    commit('updateConsultationExamsList', data);
                    await dispatch('clearRequest', "listConsultationExams");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createConsultationExam({commit, dispatch}, {userId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConsultationExam");
            return ConsultationService.createConsultationExam(axiosSource, userId, data).then(
                async data => {
                    commit('insertConsultationExam', data)
                    await dispatch('clearRequest', "createConsultationExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateConsultationExam({commit, dispatch}, {userId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateConsultationExam");
            return ConsultationService.updateConsultationExam(axiosSource, userId, data).then(
                async data => {
                    commit('updateConsultationExamData', data)
                    await dispatch('clearRequest', "updateConsultationExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteConsultationExam({commit, dispatch}, {userId, consultationExamId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteConsultationExam");
            return ConsultationService.deleteConsultationExam(axiosSource, userId, consultationExamId).then(
                async data => {
                    commit('removeConsultationExamFromList', consultationExamId)
                    await dispatch('clearRequest', "deleteConsultationExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateConsultationsList(state, data) {
            state.consultations = new Map()
            for (const entity of data) {
                state.consultations.set(entity.id, entity)
            }
        },
        insertConsultation(state, data) {
            state.consultations.set(data.id, data)
        },
        updateConsultationData(state, data) {
            state.consultations.set(data.id, data)
        },
        removeConsultationFromList(state, consultationId) {
            state.consultations.delete(consultationId)
        },
        updateConsultationSchedulesList(state, data) {
            state.consultationSchedules = new Map()
            for (const entity of data) {
                state.consultationSchedules.set(entity.id, entity)
            }
        },
        insertConsultationSchedule(state, data) {
            state.consultationSchedules.set(data.id, data)
        },
        updateConsultationScheduleData(state, data) {
            state.consultationSchedules.set(data.id, data)
        },
        removeConsultationScheduleFromList(state, consultationScheduleId) {
            state.consultationSchedules.delete(consultationScheduleId)
        },
        updateConsultationSessionsList(state, data) {
            state.consultationSessions = new Map()
            for (const entity of data) {
                state.consultationSessions.set(entity.id, entity)
            }
        },
        insertConsultationSession(state, data) {
            state.consultationSessions.set(data.id, data)
        },
        updateConsultationSessionData(state, data) {
            state.consultationSessions.set(data.id, data)
        },
        removeConsultationSessionFromList(state, consultationSessionId) {
            state.consultationSessions.delete(consultationSessionId)
        },
        updateConsultationExamsList(state, data) {
            state.consultationExams = new Map()
            for (const entity of data) {
                state.consultationExams.set(entity.id, entity)
            }
        },
        insertConsultationExam(state, data) {
            state.consultationExams.set(data.id, data)
        },
        updateConsultationExamData(state, data) {
            state.consultationExams.set(data.id, data)
        },
        removeConsultationExamFromList(state, consultationExamId) {
            state.consultationExams.delete(consultationExamId)
        },
    }
};